import React, { useMemo } from "react";
import { SubscribedChart } from "@client/components/valueDisplays/SubscribedChart";
import type { PipTelemetry } from "@client/types/pip";

interface Props {
  slug: string;
  telemetry: PipTelemetry | undefined;
}

/**
 * Grafy vývoje výkonu v čase pro detail PIP měniče (záložka Flow) — stejný graf jako hlavní
 * stránka. Hlavičky ukazují ŽIVOU hodnotu shodnou s flow diagramem; grafy kreslí 15s-průměrovanou
 * MQTT řadu.
 *
 *  - PV výkon (pv-w) — solární vstup (pvChargingPowerW)
 *  - AC výstupní výkon (ac-out-w) — výkon do zátěže (acOutputActiveW)
 */
export const PipCharts: React.FC<Props> = ({ slug, telemetry }) => {
  const prefix = `zige/pip-${slug}`;
  const pvPower = useMemo(() => [`${prefix}/pv-w/val`], [prefix]);
  const acOutPower = useMemo(() => [`${prefix}/ac-out-w/val`], [prefix]);

  return (
    <>
      <SubscribedChart topicIds={pvPower} liveValue={telemetry?.pvChargingPowerW} />
      <SubscribedChart topicIds={acOutPower} liveValue={telemetry?.acOutputActiveW} />
    </>
  );
};
